import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useDateLocale } from "../../i18n/use-date-locale";
import { builderSampleWeek } from "../../lib/metadata-builder/sample-schedule";
import { builderSessionId, useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { useMetadataHistoryStore } from "../../stores/metadata-history-store";
import { builderDayLayoutMode } from "../../lib/metadata-builder/day-layouts";
import { previewModesFor, previewSlotCounts } from "../../lib/metadata-builder/preview-modes";
import { weekdayKeys } from "../../lib/schedule-time/schedule-dates";
import { PreviewModeButtons } from "./PreviewModeButtons";

export function ArtworkPreviewControls() {
  const { t } = useTranslation();
  const locale = useDateLocale();
  const sampleDate = useMetadataBuilderStore(state => state.sampleDate);
  const previewModes = useMetadataBuilderStore(state => state.previewModes);
  const step = useMetadataBuilderStore(state => state.step);
  const previewDay = useMetadataBuilderStore(state => state.previewDay);
  const artwork = useMetadataHistoryStore(state => state.sessions[builderSessionId]?.artwork);
  if (!artwork) return null;
  const editMode = builderDayLayoutMode(step);
  const modes = editMode ? previewModesFor(editMode) : previewModes;
  const counts = previewSlotCounts(modes);
  const week = builderSampleWeek(sampleDate);
  // Review shows the mode buttons above its day grid instead.
  const showModeButtons = !editMode && step !== "review";
  return (
    <div className="mb-3 shrink-0 space-y-2">
      {showModeButtons && <PreviewModeButtons />}
      <ul className="flex flex-wrap gap-x-3 gap-y-1 text-neutral-500">{week.map((date, index) => {
        const day = weekdayKeys[index]!;
        if (editMode && previewDay && day !== previewDay) return null;
        if (!editMode && !modes[day]) return null;
        const suffix = `0${index + 1}`;
        const prefix = counts[index] === 2 ? "b" : counts[index] === 1 ? "a" : "c";
        const fallback = prefix === "c" && artwork.missingOffline.includes(`c${suffix}`);
        const file = `${fallback ? "a" : prefix}${suffix}`;
        return <li key={suffix}>{t("builder.preview.daySource", { day: format(date, "EEE", { locale }), file })}</li>;
      })}</ul>
    </div>
  );
}
